module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_WarningCircle1_16"],"path":[{"$":{"d":"M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM9,13H7V11H9ZM9,9H7V3H9Z"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_WarningCircle1_16.svg
// module id = 1wMT
// module chunks = 1